import React from "react";
import { Link as ScrollLink} from "react-scroll";
import { Link as GatsbyLink } from "gatsby";
import { OutboundLink } from "gatsby-plugin-google-gtag"

const colourVariants = {
	border: {
		plum: 'border-plum-700',
		blue: 'border-blue-700',
		orange: 'border-orange-700',
		moon: 'border-moon-700',
	},
  bg: {
		plum: 'bg-plum-700',
		blue: 'bg-blue-700',
		orange: 'bg-orange-700',
		moon: 'bg-moon-700',
	},
  bgHover: {
		plum: 'hover:bg-plum-700',
		blue: 'hover:bg-blue-700',
		orange: 'hover:bg-orange-700',
		moon: 'hover:bg-moon-700',
	},
  bgHover900: {
		plum: 'hover:bg-plum-900',
		blue: 'hover:bg-blue-900',
		orange: 'hover:bg-orange-900',
		moon: 'hover:bg-moon-900',
	},
  text: {
		plum: 'text-plum-700',
		blue: 'text-blue-700',
		orange: 'text-orange-700',
		moon: 'text-moon-700',
	},
}

export default function CtaBtn({colour, secondary, label, link, href, size, className, height, onClick, onHover, disabled, newTab}) {
    let h = 10;
    // let w = 44;
    if (size === "small") {
        h = 8;
        // w = 32;
    }
    if (size === "fit" || size=== "full" || height > 0) {
        // w=`x`;
        h=`x`;
    }
    if (link && link.startsWith('#')) {
        return (
            <div className={className}>
            <ScrollLink
                to={link.replace('#','')}
                spy={true}
                smooth={true}
                duration={500}
                style={{height}}
                onMouseOver={onHover ? () => onHover() : null}
                className={`
                    ctabtn rounded-full transition cursor-pointer
                    ${secondary ? `bg-white ${colourVariants.border[colour]} border-[1.2px] ${colourVariants.bgHover[colour]} ${colourVariants.text[colour]} hover:text-white` : `${colourVariants.bg[colour]} ${colourVariants.bgHover900[colour]} text-white` } 
                    uppercase font-title tracking-[0.04em] text-sm w-full lg:w-auto h-${h} inline-flex items-center justify-center 
                    ${size === "fit" ? 'px-4' : 'px-8'}`
                }
            >
                {label}
            </ScrollLink>
        </div>
        )
    }
    if (link) {
        return (
            <div className={className}>
            <GatsbyLink
                to={link}
                style={{height}}
                onMouseOver={onHover ? () => onHover() : null}
                className={`
                    ctabtn rounded-full transition cursor-pointer
                    ${secondary ? `bg-none ${colourVariants.border[colour]} border-[1.2px] ${colourVariants.bgHover[colour]} ${colourVariants.text[colour]} hover:text-white` : `${colourVariants.bg[colour]} ${colourVariants.bgHover900[colour]} text-white` } 
                    uppercase font-title tracking-[0.04em] text-sm w-full lg:w-auto h-${h} inline-flex items-center justify-center 
                    ${size === "fit" ? 'px-4' : 'px-8'}`
                }
            >
                {label}
            </GatsbyLink>
        </div>
        )
    }
    if (onClick) {
        return (
            <div className={className}>
                <div
                    onClick={() => onClick()}
                    onMouseOver={onHover ? () => onHover() : null}
                    style={{height}}
                    className={`
                        ctabtn rounded-full transition cursor-pointer
                        ${disabled ? 'cursor-not-allowed' : 'cursor-pointer'}
                        ${disabled ? 'bg-gray-400 text-gray-700' : secondary ? `bg-none ${colourVariants.border[colour]} border-[1.2px] ${colourVariants.bgHover[colour]} ${colourVariants.text[colour]} hover:text-white` : `${colourVariants.bg[colour]} ${colourVariants.bgHover900[colour]} text-white` } 
                        uppercase font-title tracking-[0.04em] text-sm w-full lg:w-auto h-${h} inline-flex items-center justify-center 
                        ${size === "fit" ? 'px-4' : 'px-8'}`}
                >
                    {label}
                </div>
            </div>
        )
    }
    return (
        <div className={className}>
            <OutboundLink
                href={href}
                target={newTab ? '_blank' : '_self'}
                style={{height}}
                onMouseOver={onHover ? () => onHover() : null}
                className={`
                    ctabtn rounded-full transition cursor-pointer
                    ${secondary ? `bg-none ${colourVariants.border[colour]} border-[1.2px] ${colourVariants.bgHover[colour]} ${colourVariants.text[colour]} hover:text-white` : `${colourVariants.bg[colour]} ${colourVariants.bgHover900[colour]} text-white` } 
                    uppercase font-title tracking-[0.04em] text-sm w-full lg:w-auto h-${h} inline-flex items-center justify-center 
                    ${size === "fit" ? 'px-4' : 'px-8'}`}
            >
                {label}
            </OutboundLink>
        </div>
    )
}